/**
 * @desc 获取流程实例分类
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<Array<defs.activiti.BpmFlowCategroyDto>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/bpm/getFlowCategroyList`, {
      method: "GET",

      ...options,
    }),
  );
}
